module.exports = __webpack_public_path__ + "img/icone-salvar.8e0fa37b.svg";